// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue"
import App from "./App"
import router from "./router/index"
import store from "./store"
import header from '@/components/header'
import footer from '@/components/footer'
import ViewUI from "view-design"
import "view-design/dist/styles/iview.css"
// 引入并注册公共js
import commonJs from "./base/js/common.js"
import i18n from "@/assets/lang/lang"
import { installCms, loadCms } from "@/cms"
Vue.prototype.commonJs = commonJs
installCms(Vue, store)

/* 全局事件总线 */
Vue.prototype.$baseEventBus = new Vue()

Vue.use(ViewUI)
Vue.use(ViewUI, {
  i18n: (key, value) => i18n.t(key, value)
})

Vue.component('common-footer', footer)
Vue.component('common-header', header)

Vue.config.productionTip = false

window.addEventListener('popstate', function(e) {
  router.isBack = true
}, false)

async function bootstrap() {
  try {
    await loadCms(store, i18n)
  } catch (error) {
    console.warn('CMS content is unavailable; using built-in website content.', error.message)
  }
  /* eslint-disable no-new */
  new Vue({
    el: "#app",
    i18n,
    router,
    store,
    render: h => h(App)
  })
}

bootstrap()



// WEBPACK FOOTER //
// ./src/main.js